var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntermediate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9283 15.5264C28.8842 17.2378 16.8675 22.7924 14.7298 23.779L11.4287 21.3428C11.2825 21.2332 11.0937 21.1967 10.917 21.2454L9.22994 21.6656C9.05946 21.7143 8.91327 21.83 8.83409 21.9945C8.75491 22.1589 8.75491 22.3478 8.82801 22.5122L10.917 27.0801C11.319 27.9571 12.1108 28.5662 13.0305 28.7123C13.8466 28.8403 15.1744 28.8768 16.8432 28.3104C18.9992 27.5856 22.2577 26.3858 23.8839 25.7828L22.3673 34.4314C22.3246 34.6507 22.416 34.876 22.5866 35.0161C22.6962 35.1014 22.8302 35.144 22.9642 35.144C23.0494 35.144 23.1286 35.1257 23.2078 35.0953L24.499 34.535C25.2664 34.1999 25.8815 33.597 26.2287 32.8357L30.8514 22.7193C31.9417 22.232 36.7349 20.0333 38.6961 18.2853C39.025 17.993 39.2199 17.5667 39.2259 17.1221C39.232 16.6714 39.0554 16.2389 38.7326 15.9283C37.9591 15.1914 36.1807 14.156 32.9283 15.5264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1792 16.6782L15.1194 17.2567C14.9306 17.3542 14.8149 17.5491 14.8027 17.7623C14.7905 17.9755 14.8941 18.1764 15.0768 18.2982L18.6154 20.6492C20.808 19.6443 22.6778 18.7855 24.2735 18.0607L19.0357 16.4041C18.0917 16.1057 17.0502 16.2031 16.1792 16.6782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/Intermediate.ea0d43830c54cfceccf13e38a582a5e9.svg";
export { ForwardRef as ReactComponent };